import productWaitlistService from '../../services/productWaitlistService'

class ProductWaitlistController {
  fetchProductWaitlist = productWaitlistService.fetchProductWaitlist
  addToProductWaitlist = productWaitlistService.addToProductWaitlist
  deleteFromProductWaitlist = productWaitlistService.deleteFromProductWaitlist
  addToCustomerProductWaitlist = productWaitlistService.addToCustomerProductWaitlist
}

export default new ProductWaitlistController()
 


// WEBPACK FOOTER //
// ../src/controllers/productWaitlistController/productWaitlistController.js